import { breakEvenCalculator } from './break-even';
import { cashOnCashCalculator } from './cash-on-cash';
import { soloTaxCalculator } from './solo-tax';
import type { CalculatorDefinition } from './types';
import { valuationCalculator } from './valuation';
import type { CalculatorKind } from '../types';

/**
 * The calculator registry. Adding a definition here is the only wiring a new
 * calculator needs — the index page, the route, and the prerender list all read
 * from it, so the published route set cannot drift from the content.
 */
export const CALCULATORS: CalculatorDefinition[] = [
  cashOnCashCalculator,
  valuationCalculator,
  breakEvenCalculator,
  soloTaxCalculator,
];

export function getCalculatorBySlug(slug: string): CalculatorDefinition | undefined {
  return CALCULATORS.find((c) => c.slug === slug);
}

export function getCalculatorByKind(kind: CalculatorKind): CalculatorDefinition | undefined {
  return CALCULATORS.find((c) => c.kind === kind);
}

export * from './types';
export { breakEvenCalculator, cashOnCashCalculator, soloTaxCalculator, valuationCalculator };
